const AuthType = {
    GOOGLE : 'AuthType.GOOGLE',
    FACEBOOK : 'AuthType.FACEBOOK',
    EMAIL : 'AuthType.EMAIL',
};



export default AuthType;
